'use strict';

angular.module('eclipseApp.myAccount')
  .constant('BFA_CONSTANTS', {
    APPLICATION_ID: 'Fido.ca',
    CONSOLIDATED_IND: 'NO',
    FLOW_TYPE: 'single',
    WIRELESS_IDENTIFIER: 1,
    PPC : 'ppc',
    HUP : 'hup',
    BRT_PPC_FLAG: 'FIDO_PPC_UTE_PAGE_VIEW',
    BRT_HUP_FLAG: 'FIDO_HUP_UTE_PAGE_VIEW'
  });
